module.exports = __webpack_public_path__ + "static/media/search-placeholder.96e8281f.svg";